import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#475993',
  width = '100%',
  className = '',
  viewBox = '0 0 34 34',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M29.42,0H4.584A4.582,4.582,0,0,0,0,4.582V29.418A4.582,4.582,0,0,0,4.584,34H16.833l.021-12.15H13.7a.745.745,0,0,1-.745-.742l-.015-3.916a.745.745,0,0,1,.745-.748h3.151V12.66c0-4.392,2.682-6.783,6.6-6.783h3.215a.745.745,0,0,1,.745.745v3.3a.745.745,0,0,1-.744.745H24.675c-2.13,0-2.543,1.012-2.543,2.5v3.276h4.681a.745.745,0,0,1,.74.832l-.464,3.916a.745.745,0,0,1-.74.657h-4.2L22.132,34H29.42A4.582,4.582,0,0,0,34,29.419V4.582A4.582,4.582,0,0,0,29.42,0Z"
      transform="translate(-0.002 0)"
    />
  </svg>
);

export default SVG;
